var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 326,
    viewBox: "0 0 88 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 326,
    rx: 30,
    fill: "url(#paint0_linear_1100_122622)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.55 174.67C52.84 173.54 56 169.64 56 165C56 159.48 51.56 155 46 155C39.33 155 36 160.56 36 160.56M36 160.56V156M36 160.56H38.01H40.44",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 165C36 170.52 40.48 175 46 175",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1100_122622",
    x1: 0,
    y1: 0,
    x2: 193.332,
    y2: 241.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63824,
    stopColor: "#213B98"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame9);
export default __webpack_public_path__ + "static/media/frame-9.c1e00b146c09f00e5cd4d8c988e1ea35.svg";
export { ForwardRef as ReactComponent };